module.exports = __webpack_public_path__ + "media/social/social-5-ad710506.png";